export const debounce = (func, wait) => {
  let timeout
  return function (...args) {
    const context = this
    clearTimeout(timeout)
    timeout = setTimeout(() => func.apply(context, args), wait)
  }
}

const toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is a Boolean
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
function isBoolean(val) {
  return typeof val === 'boolean';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if an object is a DOM element
 *
 * @param {Object} obj The object to test
 * @returns {boolean} True if object is an instance of the HTMLElement type
 */
function isDOMElement(obj) {
  return (
    typeof HTMLElement === "object"
      ? obj instanceof HTMLElement //DOM2
      : !!obj && typeof obj === "object" && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === "string"
  );
}

export function downloadFile(url, linkOptions = {}) {
  if (!url) {
    return;
  }

  const link = document.createElement('a');
  link.href = url;
  for (let key in linkOptions) {
    link[key] = linkOptions[key]
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function getObjectKeyByValue(object, value) {
  return Object.keys(object).find(key => object[key] === value);
}

export function formatDate(date) {
  if (!date) {
    return '-'
  }
  const dateOptions = { year: 'numeric', month: 'short', day: 'numeric' }
  return new Date(date).toLocaleString('en-GB', dateOptions).replaceAll('/', '.')
}

export function loadImage(url) {
  return new Promise(resolve => {
    const image = new Image();
    image.src = url;
    image.onload = () => resolve(image)
  })
}

export function timeout(delay = 1000) {
  return new Promise((resolve) => setTimeout(resolve, delay))
}

export default {
  debounce,
  downloadFile,
  formatDate,
  isArray,
  isFormData,
  isString,
  isNumber,
  isBoolean,
  isUndefined,
  isObject,
  isDate,
  isFile,
  isBlob,
  isFunction,
  isDOMElement,
  loadImage,
  timeout,
};
